export const CodePoint = {
	TAB: 9,
	SPACE: 32,
	NBSP: 160,
	NEW_LINE: 10, // \n
	RETURN: 13, // \r
	LINE_FEED: 12, // \f
	EXCLAMATION: 33, // !
	DOUBLE_QUOTE: 34,
	HASH: 35, // #
	SINGLE_QUOTE: 39,
	ASTERISK: 42,
	COMMA: 44,
	DOT: 46,
	COLON: 58,
	SEMI_COLON: 59,
	QUESTION: 63,
	ROUND_BRACKET_OPEN: 40,
	ROUND_BRACKET_CLOSE: 41,
	SQUARE_BRACKET_OPEN: 91,
	SQUARE_BRACKET_CLOSE: 93,
	CURLY_BRACKET_OPEN: 123,
	PIPE: 124,
	CURLY_BRACKET_CLOSE: 125,
	HYPHEN: 45,
};
